import { useNavigate } from "react-router-dom";

import dayjs from "dayjs";
import classNames from "clsx";

import Table, { TableProps } from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";

import { useThemeClassNames } from "@/hooks/useThemeClassNames";

import { transformData } from "@/utils/transformData";
import { attendanceMap } from "@/utils/mappings/attendance";

import { AttendanceStatusMessages } from "@/enums/AttendanceStatus";

import "./styles.scss";

type KeyOfAttendanceStatusMessages = keyof typeof AttendanceStatusMessages;

type Props = TableProps & {
	attendances?: Attendance[];
};

export function HospitalizationPermitsTable({ attendances, ...rest }: Props) {
	const navigate = useNavigate();

	const { border, background } = useThemeClassNames();

	const transformedAttendances = transformData<Attendance[]>(attendances || [], attendanceMap);

	function formatBirthdate(birthdate: string) {
		if (birthdate) {
			return dayjs(birthdate).format("DD/MM/YYYY");
		}

		return;
	}

	return (
		<Table className={classNames("table-attendances fs-7", border)} bordered {...rest}>
			<thead className={classNames("text-center fw-bold", background)}>
				<tr className="white-space-no-wrap">
					<th>PACIENTE</th>
					<th>STATUS</th>
					<th>CID</th>
					<th>DATA DE NASCIMENTO</th>
					<th>LEITO</th>
					<th>TEMPO DE PERMANÊNCIA</th>
					<th>AÇÕES</th>
				</tr>
			</thead>

			<tbody className="text-center align-middle">
				{transformedAttendances?.map((attendance) => (
					<tr key={attendance.id} className="border-soft-gray-bottom-1px">
						<td className="w-250px">
							{attendance.patient?.name}
							<br />
							<Badge className="text-white">
								{
									AttendanceStatusMessages[
										attendance.status as KeyOfAttendanceStatusMessages
									]
								}
							</Badge>
						</td>
						<td>
							<Badge className="bg-danger text-white">Pendente</Badge>
						</td>
						<td>{attendance.internment?.icdPrimary}</td>
						<td>{formatBirthdate(attendance.patient?.birthdate)}</td>
						<td>{attendance.bed?.location}</td>
						<td>{attendance.timeUnit}</td>
						<td className="white-space-no-wrap">
							<Button
								className="py-2 fs-8 me-2"
								onClick={() =>
									navigate(`/informacoes-aih/boletim/${attendance.id}`)
								}
							>
								Ver
							</Button>
							<Button variant="dark" className="py-2 fs-8">
								Fichas
							</Button>
						</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
}
